import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { reverse } from 'routes'

import A from 'components/A'

import './style.scss'

const images = {
  noImage: require('img/users/notUser.gif')
}


const _renderPhone = (phone) => {
  return !!phone ? (
    <div className="ClientsList__Item-contact__item">
      <p className="title">Teléfono</p>
      <p className="value">{phone}</p>
    </div>
  ) : null
}

const _renderRFC = (rfc) => {
  return !!rfc ? (
    <div className="ClientsList__Item-contact__item">
      <p className="title">RFC</p>
      <p className="value">{rfc}</p>
    </div>
  ) : null
}

const _renderCity = (city) => {
  return !!city ? (
    <div className="ClientsList__Item-basic__location">
      <span className="material-icons">location_city</span>
      <span>{city}</span>
    </div>
  ) : null
}

export default function Item(props) {
  const clientUrl = reverse('clients:detail', {id: props.user.uuid})
  const backgroundImage = !!props.user.picture ? props.user.picture : images.noImage
  const imageStyle = {
    backgroundImage: `url(${backgroundImage})`
  }

  return (
    <article className="row ClientsList__Item">
      <div className="col-md-2 ClientsList__Item-photo d-flex flex-column justify-content-between">
        <div className="ClientsList__Image" style={imageStyle}></div>
      </div>
      <div className="col-md-5 ClientsList__Item-basic d-flex flex-column justify-content-between">
        <div className="ClientsList__Item-basic__info">
          <h5><Link to={clientUrl}>{`${props.user.first_name} ${props.user.last_name}`}</Link></h5>
          <p>{props.user.email}</p>
        </div>
        {_renderCity(props.city)}
      </div>
      <div className="col-md-3 ClientsList__Item-contact d-flex flex-column justify-content-between">
        {_renderPhone(props.phone_number)}
        {_renderRFC(props.rfc)}
      </div>
      <div className="col-md-2 ClientsList__Item-more d-flex flex-column justify-content-end">
        <A to={clientUrl} aType="primary-inverse" iconName="keyboard_arrow_right" iconAlign="right">Ver Más</A>
      </div>
    </article>
  )
}


Item.propTypes = {
  city: PropTypes.string,
  is_active: PropTypes.bool,
  phone_number: PropTypes.string,
  rfc: PropTypes.string,
  user: PropTypes.shape({
    email: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    is_active: PropTypes.bool,
    is_client: PropTypes.bool,
    last_name: PropTypes.string.isRequired,
    picture: PropTypes.string,
    uuid: PropTypes.string.isRequired
  }).isRequired
}



// WEBPACK FOOTER //
// ./src/scenes/Clients/components/List/Item/index.js